export default __webpack_public_path__ + "static/media/logo.69aeb8e8.jpg";